module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_hardangled_shadow.6ec5f56d.png";